import React, { useEffect } from "react";
import { BsEnvelope, BsTelephone } from "react-icons/bs";

const policySections = [
  {
    title: "Shipping methods",
    text: "Available delivery options are confirmed according to the product, delivery location and service availability.",
    items: [
      "Standard delivery provides reliable delivery within the timeframe confirmed for your order.",
      "Expedited delivery may be available for eligible products at an additional cost.",
      "White-glove delivery, where available, may include assembly and placement in the selected room.",
    ],
  },
  {
    title: "Shipping regions",
    text: "We currently offer shipping within Pune. Availability may vary according to the exact delivery location and the product ordered.",
  },
  {
    title: "Shipping costs",
    text: "Delivery charges depend on the selected method, destination, product dimensions and weight. Applicable charges are shown or confirmed before an order is completed.",
  },
  {
    title: "Estimated delivery time",
    text: "Delivery timing depends on product availability, the selected delivery method and destination. The estimated range is provided during checkout or order confirmation. Weather, access restrictions and other logistical events may affect that estimate.",
  },
  {
    title: "Order processing",
    text: "After an order is placed, we verify availability and prepare the items for dispatch. Processing time varies by product. Dispatch and tracking details are shared when available.",
  },
  {
    title: "Tracking your order",
    text: "Eligible shipped orders receive tracking information after dispatch. You can use those details to follow delivery progress.",
  },
  {
    title: "Delivery process",
    items: [
      "Standard deliveries are made to the address supplied with the order.",
      "For assembly or placement services, the delivery path and selected room must be accessible and ready.",
      "For an approved store pickup, please carry valid identification and the order confirmation.",
    ],
  },
  {
    title: "Damaged or defective items",
    text: "Please contact Fina Interiors within two days of delivery if an item arrives damaged or defective. Our team will review the issue and explain the available repair, replacement or return resolution.",
  },
];

const ShippingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-white text-gray-900">
      <header className="site-container pt-10 md:pt-14">
        <div className="bg-[#20211d] px-5 py-10 text-white sm:px-8 md:py-14 lg:px-12">
          <p className="text-xs font-bold uppercase text-[#c49a8c]">Customer information</p>
          <h1 className="mt-3 text-3xl font-semibold md:text-5xl">Shipping policy</h1>
          <p className="mt-4 max-w-2xl text-sm leading-6 text-gray-300 md:text-base">
            Delivery methods, service areas, processing and what to expect when your
            Fina Interiors order is dispatched.
          </p>
          <p className="mt-6 text-xs text-gray-400">Effective date: 1 September 2023</p>
        </div>
      </header>

      <div className="site-container grid grid-cols-1 gap-10 py-12 md:py-16 lg:grid-cols-[minmax(0,1fr)_300px]">
        <article className="max-w-4xl">
          <div className="divide-y divide-gray-200 border-t border-gray-200">
            {policySections.map((section, index) => (
              <section key={section.title} className="grid grid-cols-[38px_1fr] gap-3 py-7 sm:grid-cols-[54px_1fr] sm:gap-5">
                <span className="text-sm font-semibold text-[#858653]">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="text-lg font-semibold md:text-xl">{section.title}</h2>
                  {section.text && (
                    <p className="mt-3 text-sm leading-7 text-gray-600">{section.text}</p>
                  )}
                  {section.items && (
                    <ul className="mt-3 space-y-2 text-sm leading-6 text-gray-600">
                      {section.items.map((item) => (
                        <li key={item} className="flex gap-3">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-[#858653]" aria-hidden="true" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </section>
            ))}
          </div>
        </article>

        <aside className="h-fit border border-gray-200 bg-[#f5f3f1] p-6 lg:sticky lg:top-32">
          <p className="text-xs font-bold uppercase text-[#858653]">Need help?</p>
          <h2 className="mt-2 text-xl font-semibold">Questions about delivery</h2>
          <p className="mt-3 text-sm leading-6 text-gray-600">
            Contact our team with your order details and delivery location.
          </p>
          <a href="tel:+919112881916" className="mt-5 flex items-center gap-3 text-sm font-medium hover:text-[#858653]">
            <BsTelephone aria-hidden="true" /> +91 91128 81916
          </a>
          <a href="mailto:finainterior29@gmail.com" className="mt-4 flex items-start gap-3 break-all text-sm font-medium hover:text-[#858653]">
            <BsEnvelope className="mt-0.5 shrink-0" aria-hidden="true" />
            finainterior29@gmail.com
          </a>
        </aside>
      </div>
    </main>
  );
};

export default ShippingPolicy;
